import cx from 'classnames'
import styles from './HeroGeneralInfo.module.scss'
import { HeroGeneralInfoProps, HeroInfoBarLinkProps, ImageProps } from '~types'
import { Heading, HeroInfoBarLink, Paragraph } from '~elements'
import { useWindowSize } from 'utils/hooks'

const HeroGeneralInfo = ({
  headline,
  copy,
  infoItems,
  backgroundImageXl,
  backgroundImageSm,
  showBackgroundImage
}: HeroGeneralInfoProps) => {
  const { isBreakpoint: isBelowBreakpointSm } = useWindowSize('sm', '<')
  const generalInfoImg = isBelowBreakpointSm ? backgroundImageSm : backgroundImageXl

  const getInfoImageWidth = (image: ImageProps) => (isBelowBreakpointSm ? 22 : image?.image?.width ?? 23)
  const getInfoImageHeight = (image: ImageProps) => (isBelowBreakpointSm ? 20 : image?.image.height ?? 20)

  const showInfoClass =
    infoItems && infoItems.length > 2
      ? cx([styles['show-info'], styles['justify-between']])
      : cx([styles['show-info'], styles['justify-around']])

  const generalInfoItems = (
    <div className={showInfoClass}>
      {infoItems.map(({ anchorText, url, image }: HeroInfoBarLinkProps) => (
        <HeroInfoBarLink
          key={anchorText}
          imageWidth={getInfoImageWidth(image)}
          imageHeight={getInfoImageHeight(image)}
          imageUrl={image?.image?.url}
          url={url}
          anchorText={anchorText}
        />
      ))}
    </div>
  )

  return (
    <div className={cx(styles['hero-general-info'], generalInfoImg?.url ? styles['has-header'] : [])}>
      <div className={styles['hero-general-info-container']}>
        <div className={styles['general-info']}>
          {(headline || copy) && (
            <div>
              {headline && (
                <Heading level={2} justify='center'>
                  {headline}
                </Heading>
              )}
              {copy && copy?.html && <Paragraph text={copy} justify='center' fontSize='sm' noMarginBottom />}
            </div>
          )}
          {infoItems && infoItems.length > 0 && generalInfoItems}
        </div>
      </div>
      {showBackgroundImage && (
        <div className={styles['general-info__bg-img']} style={{ backgroundImage: `url(${generalInfoImg?.url})` }} />
      )}
    </div>
  )
}

export default HeroGeneralInfo
